// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__v3l8m"};